import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { CycleDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { CYCLE_DEFAULT_TAB, CYCLE_SHOW_TABS } from '../constants';
import { CycleShowHeader } from './CycleShowHeader';
import { CycleGeneralTab } from './CycleGeneralTab';
import { CycleDeltaLogCard } from './CycleDeltaLogCard';

export const CycleShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<CycleDetailOut>({
    resource: 'settlement.cycles',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('settlement.cycles', record && `#${record.id}`);

  const [activeTab, onTabChange] = useShowTab(
    CYCLE_SHOW_TABS,
    CYCLE_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <CycleShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && <CycleGeneralTab record={record} />}
            {activeTab === 'delta_log' && (
              <CycleDeltaLogCard cycleId={record.id} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
